import React from 'react';

const FloatingButtons = () => {
  const phoneNumber = '+916260094621'; // Replace with your phone number
  const whatsappNumber = '+916260094621'; // Replace with your WhatsApp number

  return (
    <div className="fixed bottom-0 right-0 flex flex-col space-y-2 m-4 z-[5000]">
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${whatsappNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="w-16 h-16 opacity-80 hover:opacity-100 bg-green-500 hover:bg-green-600 text-white flex items-center justify-center rounded-full shadow-lg"
      >
        <i className="fab fa-whatsapp text-4xl"></i>
      </a>

      {/* Call Button */}
      <a
        href={`tel:${phoneNumber}`}
        className="w-16 h-16 bg-black opacity-75 hover:opacity-90 hover:bg-gray-800 text-white flex items-center justify-center rounded-full shadow-lg"
      >
        <i className="fas fa-phone text-xl"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
